import supabase from '@/lib/supabaseClient';

const API_BASE = (process.env.REACT_APP_API_BASE_URL || '').trim();

// Local-dev convenience only -- must never resolve to a backend URL for any
// non-localhost hostname, or a misconfigured REACT_APP_API_BASE_URL on a
// real deploy (staging or production) would silently route live traffic to
// the dev Railway backend instead of failing loudly.
function getFallbackApiBase() {
  if (typeof window === 'undefined') return '';

  const { hostname } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://127.0.0.1:8001';
  }

  return '';
}

async function fetchApprovalStatusFromBackend(accessToken) {
  const requestOptions = {
    method: 'GET',
    headers: { Authorization: `Bearer ${accessToken}` },
  };

  const fetchStatus = async (baseUrl) => {
    const response = await fetch(`${baseUrl}/api/auth/approval-status`, requestOptions);
    if (!response.ok) {
      const body = await response.text();
      throw new Error(`approval-status returned ${response.status}${body ? `: ${body}` : ''}`);
    }
    return response.json();
  };

  try {
    return await fetchStatus(API_BASE);
  } catch (error) {
    if (API_BASE) throw error;
  }

  const fallbackApiBase = getFallbackApiBase();
  if (!fallbackApiBase) {
    throw new Error('No API base configured for approval status');
  }

  return fetchStatus(fallbackApiBase);
}

export async function getApprovalStatus({ userId, accessToken }) {
  if (!userId) {
    return { adminApproved: null, source: 'none' };
  }

  if (accessToken) {
    try {
      const payload = await fetchApprovalStatusFromBackend(accessToken);
      const adminApproved = payload?.admin_approved;
      if (adminApproved === true || adminApproved === false) {
        return { adminApproved, source: 'backend' };
      }
      return { adminApproved: null, source: 'backend' };
    } catch (backendError) {
      return { adminApproved: null, source: 'backend', error: backendError };
    }
  }

  return { adminApproved: null, source: 'none' };
}
